import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import renderHTML from 'react-render-html';
import ServiceParams from '../../shared/serviceParams/ServiceParams';
import './ServicePage.css';

class ServicePage extends Component {
    render() {
        var serviceData = this.props.ServiceData;
        var params = serviceData.wsdlparams.map(wsdlpara => {
            return <ServiceParams wsdlDoc={wsdlpara} key={wsdlpara.title} />
        })
        return (
            <div className="service-content">
                <h1 className="service-heading">
                    {serviceData.parent}
                </h1>
                <div>
                    <h2 className="service-subheading">{serviceData.title}</h2>
                    <div className="service-main-content">
                    <p>
                        {renderHTML(serviceData.content)}</p>                    
                        <h3>
                            WSDL URL</h3>
                        <p>
                            {serviceData.wsdlContent}</p>
                        <p>
                            <b>{serviceData.notice}</b></p>
                        <br />                    
                    {params}
                    </div>
                    <br/>
                    <Link className="service-content-link" to={this.props.backLink}>Back</Link>
                    <br />
                    <br />
                </div>
            </div>
        )
    }
}

ServicePage.propTypes = {
    ServiceData: PropTypes.object,
    backLink: PropTypes.string
}

export default ServicePage;